<div class="container wide grey-square-wrapper">
  <span
    class="grey-square"
    [ngStyle]="{'width': width, 'height' : height, 'left' : left, 'right' : right, 'top' : top, 'bottom' : bottom, 'background' : background}"
    [ngClass]="additionalClasses"
  ></span>
  <ng-content></ng-content>
</div>

